import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getLabelsList(axiosPrivate, mineOnly = false) {
	return axiosPrivate
		.get(`${apiURL}/decision/label.json?mineOnly=${mineOnly}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteLabel(axiosPrivate, cb, labelId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/label/${labelId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Label deleted");
				cb();
			} else {
				toast.error("Failed to delete label");
			}
		})
		.catch((err) => err.response);
}

export async function editLabel(axiosPrivate, cb, decisionLabelId, data) {
	return axiosPrivate
		.put(`${apiURL}/decision/label/${decisionLabelId}.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Label - updated");
				cb();
			} else {
				toast.error("Label failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addLabel(axiosPrivate, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/decision/label.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Label - updated");
				cb();
			} else {
				toast.error("Label failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
